($ => {
	// Use it like so => 
	// for the emitter (input only): <input data-bind="myKey" />
	// for the receiver (any tag will do except input): <div data-bind="myKey"></div>
	function init() {
		$('input[data-bind]').keyup(({ currentTarget }) => {
			// Get the value and the binding
			const { value, dataset: { bind } } = currentTarget;
			// Find the recipient and set the value
			$(`[data-bind=${bind}]:not(input)`).html(value);
		});
	}

	$(init);
})(jQuery);
